module.exports = __webpack_public_path__ + "static/media/beep.ed49258a.wav";